// ---------------------------------------------------------------------------
// Block Definition: paragraph (DocDsl)
//
// Text paragraph with optional inline markdown formatting (runs).
// LLM generates paragraph text from source.
// ---------------------------------------------------------------------------

const EVIDENCE_DESC = "Verbatim sentence(s) from the SOURCE that justify this value — quote exactly, do not paraphrase. If combining separate spans, join them with ' … '. null if not directly stated.";

function nullable(type, description, extra = {}) {
  const t = Array.isArray(type) ? type : [type, "null"];
  return { type: t, ...(description ? { description } : {}), ...extra };
}

export const paragraphDef = {
  type: "paragraph",
  label: "Paragraph",
  description: "Text paragraph with inline bold/italic formatting.",

  crystallizer: {
    extractionPhases: ["llm"],

    buildDataSchema(block, opts) {
      const prompt = block.prompt || block._prompt || "Write a paragraph summarizing the relevant information from the source.";
      const maxWords = block.max_words || 100;
      const props = { text: nullable("string", `${prompt} (max ${maxWords} words)`) };
      if (block.cite) props.text__evidence = nullable("string", EVIDENCE_DESC);
      return { type: "object", properties: props, required: Object.keys(props), additionalProperties: false };
    },

    buildShapeDescription(block) {
      const maxWords = block.max_words || 100;
      return `{ "text": "<string>" }  // Paragraph (max ${maxWords} words)`;
    },

    isBlockLevelTarget() { return true; },
    skipFromPinSchema() { return false; },
    isCodeDerived() { return false; },
    collectHints() { return []; },
    buildPromptSupplement() { return ""; },
    postProcess(data) { return data; },
  },

  renderer: null, // wired by ui/src/blockRegistryInit.js

  editor: {
    icon: "paragraph",
    category: "text",
    defaultTemplate: { type: "paragraph", max_words: 100 },
    configFields: [
      { name: "max_words", type: "number", label: "Max words", defaultValue: 100 },
      { name: "alignment", type: "select", label: "Alignment", options: ["left", "center", "right", "justify"], defaultValue: "left" },
    ],
  },
};
